var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CModal',{attrs:{"title":"System Message","color":_vm.color,"show":_vm.alert.message!=null,"closeOnBackdrop":false,"showCancel":false},on:{"okClicked":_vm.backBtn,"closeClicked":_vm.backBtn}},[_c('div',{staticClass:"my-3 row"},[_c('div',{staticClass:"form-group col-lg-12"},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }